"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = void 0;
class EventEmitter {
    constructor() {
        this.listeners = new Map();
    }
    on(event, listener) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, []);
        }
        this.listeners.get(event).push(listener);
    }
    removeListener(event, listener) {
        const listeners = this.listeners.get(event);
        if (listeners && listeners.length) {
            this.listeners.set(event, listeners.filter(l => l !== listener));
        }
    }
    emit(event, data) {
        const listeners = this.listeners.get(event);
        if (listeners && listeners.length) {
            listeners.forEach(listener => {
                listener(data);
            });
        }
    }
}
exports.EventEmitter = EventEmitter;
